import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { t } from '@/i18n';

/** FA(3) RodzajFaktury values that denote a correction invoice. */
const CORRECTION_KINDS = new Set(['KOR', 'KOR_ZAL', 'KOR_ROZ']);

export const isCorrectionInvoice = (rodzajFaktury?: string | null): boolean =>
  rodzajFaktury != null && CORRECTION_KINDS.has(rodzajFaktury);

const KIND_TOOLTIP_KEYS: Record<string, string> = {
  KOR: 'invoices.correction.tooltipKor',
  KOR_ZAL: 'invoices.correction.tooltipKorZal',
  KOR_ROZ: 'invoices.correction.tooltipKorRoz',
};

/**
 * Marks a correction invoice (faktura korygująca) on invoice lists, so KOR*
 * rows read apart from regular VAT invoices at a glance. Renders nothing for
 * non-correction kinds.
 */
export function CorrectionBadge({ rodzajFaktury }: { rodzajFaktury?: string | null }) {
  if (!isCorrectionInvoice(rodzajFaktury)) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          className="border-amber-500/40 bg-amber-500/10 px-1.5 py-0 text-[10px] font-normal text-amber-700 dark:text-amber-400"
        >
          {t('invoices.correction.badge')}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        {t(KIND_TOOLTIP_KEYS[rodzajFaktury!] || 'invoices.correction.tooltipKor')}
      </TooltipContent>
    </Tooltip>
  );
}
